export interface TweenFormatOptions {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
}

/** Fraction digits `value` needs under `options`: the configured
 * `maximumFractionDigits` when set, else however many its own default
 * formatting renders. */
const fractionDigitsOf = (
    value: number,
    options?: TweenFormatOptions
): number => {
    if (options?.maximumFractionDigits !== undefined) {
        return options.maximumFractionDigits;
    }
    const formatted = value.toLocaleString('en-US', options);
    const dot = formatted.indexOf('.');
    return dot === -1 ? 0 : formatted.length - dot - 1;
};

/** Formats a tweening figure with a fixed decimal count while it moves, so
 * an intermediate frame's width never shifts against the landed value. At
 * rest (`tweened` reaches `target`) the caller's own formatting applies,
 * unchanged. */
export const formatTweenedNumber = (
    tweened: number,
    target: number,
    options?: TweenFormatOptions
): string => {
    if (Object.is(tweened, target)) {
        return target.toLocaleString('en-US', options);
    }
    const digits = fractionDigitsOf(target, options);
    return tweened.toLocaleString('en-US', {
        ...options,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    });
};
